//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div class="go_qr">
    <TitleSubtitle
      :title="page.title"
      :subtitle="page.subtitle"
      :titleStyle="{ fontWeight: 300 }"
      :subtitleStyle="{ fontWeight: 300, fontSize: '14px' }"
    />
    <div
      v-if="store.state.Session.qrRefreshNeeded"
      class="go_qr_refresh_banner"
      role="alert"
    >
      <span class="go_qr_refresh_text"
        >This QR code has expired. Please refresh the page to get a new
        one.</span
      >
      <button type="button" class="go_qr_refresh_btn" @click="refreshPage">
        Refresh page
      </button>
    </div>
    <div v-if="!store.state.Session.qrRefreshNeeded" class="go_qr_container">
      <qrcode
        :value="qrInfo"
        :color="{ light: store.state.Style.backgroundColor }"
        type="image/png"
        @change="qrRendered"
      />
      <CheckmarkAnimation
        v-if="startAnimation"
        :analyticsEvent="checkmarkEvent"
      />
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { defineProps, computed, inject } from "vue";

import AnalyticsEvent from "@/../../../common/models/AnalyticsEvent.js";

import TitleSubtitle from "@/components/TitleSubtitle.vue";
import Qrcode from "vue-qrcode";
import CheckmarkAnimation from "@/components/sections/qrScanPages/CheckmarkAnimation.vue";

defineProps(["page", "startAnimation"]);
const store = useStore();
const api = inject("api");

const qrInfo = computed(() => {
  return `${store.getters["Session/socket_id"]};${api.config.clientConfig.serverUrl}/;${api.config.appConfig.env};;`;
});

const checkmarkEvent = new AnalyticsEvent("pv web qr scanned", "pv", "good");

function qrRendered() {
  api.analytics.log(
    new AnalyticsEvent("pv web qr generation success", "pv", "good")
  );
}

function refreshPage() {
  window.location.reload();
}
</script>

<style scoped lang="scss">
.go_qr_refresh_banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  margin-bottom: 16px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
}
.go_qr_refresh_text {
  font-size: 14px;
  color: #856404;
  text-align: center;
}
.go_qr_refresh_btn {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #856404;
  background: #fff;
  border: 1px solid #ffc107;
  border-radius: 6px;
  cursor: pointer;
}
.go_qr_refresh_btn:hover {
  background: #ffe69c;
}
.go_qr {
  margin-top: -20%;

  .go_qr_container {
    width: 270px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
    }
  }
}
</style>
